import { GlobalWorkerOptions } from 'pdfjs-dist/legacy/build/pdf';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
import workerSrc from '!file-loader!pdfjs-dist/legacy/build/pdf.worker';

GlobalWorkerOptions.workerSrc = workerSrc;
